 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CompanyProfile":"CompanyProfile","Customer~Task~account~advanceReport~bank~barcodeScan~branch~completeReport~daily~dailyrestaurantlist~0acc2a80":"Customer~Task~account~advanceReport~bank~barcodeScan~branch~completeReport~daily~dailyrestaurantlist~0acc2a80","Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~50ccefb2":"Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~50ccefb2","Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~528a17f4":"Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~528a17f4","Customer":"Customer","bank":"bank","branch":"branch","orderList":"orderList","daily":"daily","debtorAndcreditor":"debtorAndcreditor","townshipAndCity":"townshipAndCity","OsNoti~Task~account~advanceReport~completeReport~dailypercent~dailyrestaurantlist~dailyriderlist~dai~f7653cec":"OsNoti~Task~account~advanceReport~completeReport~dailypercent~dailyrestaurantlist~dailyriderlist~dai~f7653cec","Task":"Task","account":"account","advanceReport":"advanceReport","deliveryReport":"deliveryReport","deliveryStatement":"deliveryStatement","expense":"expense","income":"income","manageOrder":"manageOrder","manageOrderMultiple":"manageOrderMultiple","onlineDetailStatementReport":"onlineDetailStatementReport","onlineShopping":"onlineShopping","payment":"payment","completeReport~expenseReport~incomeReport~profitAndLoss~restAnalyze~riderAnalyze~riderTime~saleReport":"completeReport~expenseReport~incomeReport~profitAndLoss~restAnalyze~riderAnalyze~riderTime~saleReport","expenseReport":"expenseReport","incomeReport":"incomeReport","completeReport":"completeReport","profitAndLoss":"profitAndLoss","restAnalyze":"restAnalyze","riderAnalyze":"riderAnalyze","riderTime":"riderTime","saleReport":"saleReport","dailyrestaurantlist":"dailyrestaurantlist","dailyriderlist":"dailyriderlist","dailyriderpaylist":"dailyriderpaylist","finance":"finance","orderos":"orderos","barcodeScan":"barcodeScan","uiui":"uiui","Home":"Home","Map":"Map","OsNoti":"OsNoti","dailypercent":"dailypercent","Setting":"Setting","TrackingStatus":"TrackingStatus","barcodeGenerate":"barcodeGenerate","incomeexpense":"incomeexpense","login":"login","rating":"rating","report":"report","settings":"settings","statement":"statement","voucherPrint":"voucherPrint"}[chunkId]||chunkId) + "." + {"CompanyProfile":"84b3f24a","Customer~Task~account~advanceReport~bank~barcodeScan~branch~completeReport~daily~dailyrestaurantlist~0acc2a80":"2e36cee9","Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~50ccefb2":"b3b2c695","Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~528a17f4":"00ee9d9f","Customer":"15065c03","bank":"7f36b374","branch":"6d3b9c26","chunk-701a8a6c":"e45bee76","orderList":"7b4a5807","daily":"fcd9a71e","debtorAndcreditor":"8f8eb0ec","townshipAndCity":"915a8062","OsNoti~Task~account~advanceReport~completeReport~dailypercent~dailyrestaurantlist~dailyriderlist~dai~f7653cec":"a29335c3","Task":"92c74697","account":"598dd26b","advanceReport":"d6f3af77","deliveryReport":"a3f6c5c4","deliveryStatement":"7979b9ce","expense":"f35a6ec8","income":"f5f923b5","manageOrder":"f28bfb77","manageOrderMultiple":"8ed7d33b","onlineDetailStatementReport":"fc51562f","onlineShopping":"d9ec77d5","payment":"1ac72fbf","completeReport~expenseReport~incomeReport~profitAndLoss~restAnalyze~riderAnalyze~riderTime~saleReport":"5b21b7fd","expenseReport":"25913aa6","incomeReport":"0e4a3355","completeReport":"dd7395a3","profitAndLoss":"563c4e93","restAnalyze":"f5f7563c","riderAnalyze":"1fc45446","riderTime":"21ab5c73","saleReport":"1bdbf51b","dailyrestaurantlist":"6a32b3ff","dailyriderlist":"9c528155","dailyriderpaylist":"dd89cd47","finance":"e45b31db","orderos":"db6113fc","barcodeScan":"d591d990","uiui":"8a745dfe","Home":"319babb8","Map":"a936d661","OsNoti":"a2df8597","dailypercent":"e9000394","Setting":"d5667d6f","TrackingStatus":"7efd0b68","barcodeGenerate":"712e2d76","incomeexpense":"681b1d62","login":"5aefe2c2","rating":"3e87515c","report":"f3c2e1cf","settings":"cb4aa30e","statement":"d9324d9c","voucherPrint":"3fcd2fac","chunk-68a38b33":"17cade20","chunk-b23a0d24":"4ece621c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CompanyProfile":1,"Customer~Task~account~advanceReport~bank~barcodeScan~branch~completeReport~daily~dailyrestaurantlist~0acc2a80":1,"Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~50ccefb2":1,"Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~528a17f4":1,"Customer":1,"branch":1,"orderList":1,"daily":1,"debtorAndcreditor":1,"townshipAndCity":1,"OsNoti~Task~account~advanceReport~completeReport~dailypercent~dailyrestaurantlist~dailyriderlist~dai~f7653cec":1,"Task":1,"account":1,"advanceReport":1,"deliveryReport":1,"deliveryStatement":1,"expense":1,"income":1,"manageOrder":1,"manageOrderMultiple":1,"onlineDetailStatementReport":1,"onlineShopping":1,"payment":1,"expenseReport":1,"incomeReport":1,"completeReport":1,"profitAndLoss":1,"restAnalyze":1,"riderAnalyze":1,"riderTime":1,"saleReport":1,"dailyrestaurantlist":1,"dailyriderlist":1,"dailyriderpaylist":1,"finance":1,"orderos":1,"uiui":1,"Home":1,"OsNoti":1,"dailypercent":1,"Setting":1,"TrackingStatus":1,"login":1,"rating":1,"voucherPrint":1,"chunk-68a38b33":1,"chunk-b23a0d24":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CompanyProfile":"CompanyProfile","Customer~Task~account~advanceReport~bank~barcodeScan~branch~completeReport~daily~dailyrestaurantlist~0acc2a80":"Customer~Task~account~advanceReport~bank~barcodeScan~branch~completeReport~daily~dailyrestaurantlist~0acc2a80","Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~50ccefb2":"Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~50ccefb2","Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~528a17f4":"Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~528a17f4","Customer":"Customer","bank":"bank","branch":"branch","orderList":"orderList","daily":"daily","debtorAndcreditor":"debtorAndcreditor","townshipAndCity":"townshipAndCity","OsNoti~Task~account~advanceReport~completeReport~dailypercent~dailyrestaurantlist~dailyriderlist~dai~f7653cec":"OsNoti~Task~account~advanceReport~completeReport~dailypercent~dailyrestaurantlist~dailyriderlist~dai~f7653cec","Task":"Task","account":"account","advanceReport":"advanceReport","deliveryReport":"deliveryReport","deliveryStatement":"deliveryStatement","expense":"expense","income":"income","manageOrder":"manageOrder","manageOrderMultiple":"manageOrderMultiple","onlineDetailStatementReport":"onlineDetailStatementReport","onlineShopping":"onlineShopping","payment":"payment","completeReport~expenseReport~incomeReport~profitAndLoss~restAnalyze~riderAnalyze~riderTime~saleReport":"completeReport~expenseReport~incomeReport~profitAndLoss~restAnalyze~riderAnalyze~riderTime~saleReport","expenseReport":"expenseReport","incomeReport":"incomeReport","completeReport":"completeReport","profitAndLoss":"profitAndLoss","restAnalyze":"restAnalyze","riderAnalyze":"riderAnalyze","riderTime":"riderTime","saleReport":"saleReport","dailyrestaurantlist":"dailyrestaurantlist","dailyriderlist":"dailyriderlist","dailyriderpaylist":"dailyriderpaylist","finance":"finance","orderos":"orderos","barcodeScan":"barcodeScan","uiui":"uiui","Home":"Home","Map":"Map","OsNoti":"OsNoti","dailypercent":"dailypercent","Setting":"Setting","TrackingStatus":"TrackingStatus","barcodeGenerate":"barcodeGenerate","incomeexpense":"incomeexpense","login":"login","rating":"rating","report":"report","settings":"settings","statement":"statement","voucherPrint":"voucherPrint"}[chunkId]||chunkId) + "." + {"CompanyProfile":"246d22c7","Customer~Task~account~advanceReport~bank~barcodeScan~branch~completeReport~daily~dailyrestaurantlist~0acc2a80":"0e0bf411","Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~50ccefb2":"9f513c3c","Customer~Task~account~advanceReport~bank~branch~daily~debtorAndcreditor~deliveryReport~deliveryState~528a17f4":"c8488c3e","Customer":"ca6df252","bank":"31d6cfe0","branch":"d3de4bc2","chunk-701a8a6c":"31d6cfe0","orderList":"d3b552a1","daily":"611583dc","debtorAndcreditor":"3bb25ff6","townshipAndCity":"d3de4bc2","OsNoti~Task~account~advanceReport~completeReport~dailypercent~dailyrestaurantlist~dailyriderlist~dai~f7653cec":"6aa76c4d","Task":"6f620991","account":"ee4eaae3","advanceReport":"1d4ba420","deliveryReport":"6ca11e93","deliveryStatement":"191806e3","expense":"d3de4bc2","income":"ab5ca5d8","manageOrder":"34911bb7","manageOrderMultiple":"5d7404f6","onlineDetailStatementReport":"5b127d26","onlineShopping":"3540266a","payment":"7732819f","completeReport~expenseReport~incomeReport~profitAndLoss~restAnalyze~riderAnalyze~riderTime~saleReport":"31d6cfe0","expenseReport":"7f22813f","incomeReport":"88aff017","completeReport":"91f5b026","profitAndLoss":"73c4dc9a","restAnalyze":"9828e3fd","riderAnalyze":"de14b8e0","riderTime":"6f6d5aa4","saleReport":"b994deb6","dailyrestaurantlist":"54809fa4","dailyriderlist":"342a01c5","dailyriderpaylist":"a6605dcd","finance":"9c87ee04","orderos":"d3de4bc2","barcodeScan":"31d6cfe0","uiui":"a78dfd29","Home":"acf5ac6c","Map":"31d6cfe0","OsNoti":"9e3dd7c6","dailypercent":"297ddab0","Setting":"6bcc295c","TrackingStatus":"9ab39da2","barcodeGenerate":"31d6cfe0","incomeexpense":"31d6cfe0","login":"be1ae59e","rating":"31d3bb0c","report":"31d6cfe0","settings":"31d6cfe0","statement":"31d6cfe0","voucherPrint":"b912675c","chunk-68a38b33":"b024740f","chunk-b23a0d24":"b024740f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
